"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Graphics = require("../../graphics");

var Specification = require("../../specification");

var emphasis_1 = require("./emphasis");

var icon_attrs_1 = require("./icon.attrs");

var image_1 = require("./image");

var IconElementClass =
/*#__PURE__*/
function (_emphasis_1$Emphasiza) {
  _inherits(IconElementClass, _emphasis_1$Emphasiza);

  function IconElementClass() {
    var _this;

    _classCallCheck(this, IconElementClass);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconElementClass).apply(this, arguments));
    _this.attributes = icon_attrs_1.iconAttributes;
    _this.attributeNames = Object.keys(icon_attrs_1.iconAttributes);
    return _this;
  }

  _createClass(IconElementClass, [{
    key: "initializeState",
    value: function initializeState() {
      _get(_getPrototypeOf(IconElementClass.prototype), "initializeState", this).call(this);

      var attrs = this.state.attributes;
      attrs.x = 0;
      attrs.y = 0;
      attrs.size = 400;
      attrs.opacity = 1;
      attrs.visible = true;
      attrs.image = null;
    }
    /** Get link anchors for this mark */

  }, {
    key: "getLinkAnchors",
    value: function getLinkAnchors(mode) {
      var attrs = this.state.attributes;
      return [{
        element: this.object._id,
        points: [{
          x: attrs.x,
          y: attrs.y,
          xAttribute: "x",
          yAttribute: "y",
          direction: {
            x: mode == "begin" ? 1 : -1,
            y: 0
          }
        }]
      }];
    }
  }, {
    key: "getLayoutProps",
    value: function getLayoutProps() {
      var attrs = this.state.attributes;
      var image = attrs.image || image_1.imagePlaceholder;

      if (attrs.size <= 0) {
        return {
          width: 0,
          height: 0,
          dx: 0,
          dy: 0
        };
      }

      var h = Math.sqrt(attrs.size * image.height / image.width);
      var w = h * image.width / image.height;
      var offsets = this.getCenterOffset(this.object.properties.alignment, w, h);
      return {
        width: w,
        height: h,
        dx: offsets[0],
        dy: offsets[1]
      };
    }
  }, {
    key: "getCenterOffset",
    value: function getCenterOffset(alignment, width, height) {
      var cx = width / 2,
          cy = height / 2;

      if (alignment.x == "left") {
        cx = -alignment.xMargin;
      }

      if (alignment.x == "right") {
        cx = width + alignment.xMargin;
      }

      if (alignment.y == "bottom") {
        cy = -alignment.yMargin;
      }

      if (alignment.y == "top") {
        cy = height + alignment.yMargin;
      }

      return [cx, cy];
    } // Get the graphical element from the element

  }, {
    key: "getGraphics",
    value: function getGraphics(cs, offset) {
      var glyphIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var manager = arguments.length > 3 ? arguments[3] : undefined;
      var emphasize = arguments.length > 4 ? arguments[4] : undefined;
      var attrs = this.state.attributes;

      if (!attrs.visible || !this.object.properties.visible) {
        return null;
      }

      if (attrs.size <= 0) {
        return null;
      }

      var image = attrs.image || image_1.imagePlaceholder; // Compute w, h to resize the image to the desired size

      var layout = this.getLayoutProps();
      var gImage = Graphics.makeGroup([{
        type: "image",
        src: image.src,
        x: -layout.dx,
        y: -layout.dy,
        width: layout.width,
        height: layout.height,
        mode: "stretch"
      }]);
      gImage.transform = cs.getLocalTransform(attrs.x + offset.x, attrs.y + offset.y);
      gImage.transform.angle += this.object.properties.rotation;
      return gImage;
    } // Get DropZones given current state

  }, {
    key: "getDropZones",
    value: function getDropZones() {
      return [Object.assign({
        type: "rectangle"
      }, this.getBoundingRectangle(), {
        title: "size",
        dropAction: {
          scaleInference: {
            attribute: "size",
            attributeType: Specification.AttributeType.Number
          }
        }
      })];
    } // Get bounding rectangle given current state

  }, {
    key: "getHandles",
    value: function getHandles() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y;
      var bbox = this.getBoundingRectangle();
      var props = this.object.properties;
      return [{
        type: "point",
        x: x,
        y: y,
        actions: [{
          type: "attribute",
          source: "x",
          attribute: "x"
        }, {
          type: "attribute",
          source: "y",
          attribute: "y"
        }]
      }, {
        type: "text-alignment",
        actions: [{
          type: "property",
          source: "alignment",
          property: "alignment"
        }, {
          type: "property",
          source: "rotation",
          property: "rotation"
        }, {
          type: "attribute-value-mapping",
          source: "text",
          attribute: "text"
        }],
        textWidth: bbox.width,
        textHeight: bbox.height,
        anchorX: x,
        anchorY: y,
        text: null,
        alignment: props.alignment,
        rotation: props.rotation
      }];
    }
  }, {
    key: "getBoundingRectangle",
    value: function getBoundingRectangle() {
      var attrs = this.state.attributes;
      var rotation = this.object.properties.rotation;
      var layout = this.getLayoutProps();
      var cos = Math.cos(rotation / 180 * Math.PI);
      var sin = Math.sin(rotation / 180 * Math.PI);
      var dx = layout.dx - layout.width / 2;
      var dy = layout.dy - layout.height / 2;
      return {
        cx: attrs.x - dx * cos + dy * sin,
        cy: attrs.y - dx * sin - dy * cos,
        width: layout.width,
        height: layout.height,
        rotation: rotation
      };
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox() {
      var rect = this.getBoundingRectangle();
      var attrs = this.state.attributes;
      return {
        type: "anchored-rectangle",
        anchorX: attrs.x,
        anchorY: attrs.y,
        cx: rect.cx - attrs.x,
        cy: rect.cy - attrs.y,
        width: rect.width,
        height: rect.height,
        rotation: rect.rotation
      };
    }
  }, {
    key: "getSnappingGuides",
    value: function getSnappingGuides() {
      var attrs = this.state.attributes;
      var x = attrs.x,
          y = attrs.y;
      return [{
        type: "x",
        value: x,
        attribute: "x"
      }, {
        type: "y",
        value: y,
        attribute: "y"
      }];
    }
  }, {
    key: "getAttributePanelWidgets",
    value: function getAttributePanelWidgets(manager) {
      var props = this.object.properties;
      var widgets = [manager.sectionHeader("Icon"), manager.mappingEditor("Image", "image", {}), manager.mappingEditor("Size", "size", {
        acceptKinds: [Specification.DataKind.Numerical],
        hints: {
          rangeNumber: [0, 100]
        },
        defaultValue: 400,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          sliderRange: [0, 3600],
          sliderFunction: "sqrt"
        }
      })];
      widgets = widgets.concat([manager.sectionHeader("Anchor & Rotation"), manager.row("Anchor X", manager.horizontal([0, 1], manager.inputSelect({
        property: "alignment",
        field: "x"
      }, {
        type: "radio",
        icons: ["text-align/left", "text-align/x-middle", "text-align/right"],
        labels: ["Left", "Middle", "Right"],
        options: ["left", "middle", "right"]
      }), props.alignment.x != "middle" ? manager.horizontal([0, 1], manager.label("Margin:"), manager.inputNumber({
        property: "alignment",
        field: "xMargin"
      })) : null)), manager.row("Anchor Y", manager.horizontal([0, 1], manager.inputSelect({
        property: "alignment",
        field: "y"
      }, {
        type: "radio",
        icons: ["text-align/top", "text-align/y-middle", "text-align/bottom"],
        labels: ["Top", "Middle", "Bottom"],
        options: ["top", "middle", "bottom"]
      }), props.alignment.y != "middle" ? manager.horizontal([0, 1], manager.label("Margin:"), manager.inputNumber({
        property: "alignment",
        field: "yMargin"
      })) : null)), manager.sectionHeader("Style"), manager.mappingEditor("Opacity", "opacity", {
        hints: {
          rangeNumber: [0, 1]
        },
        defaultValue: 1,
        numberOptions: {
          showSlider: true,
          minimum: 0,
          maximum: 1
        }
      }), manager.mappingEditor("Visibility", "visible", {
        defaultValue: true
      })]);
      return widgets;
    }
  }]);

  return IconElementClass;
}(emphasis_1.EmphasizableMarkClass);

IconElementClass.classID = "mark.icon";
IconElementClass.type = "mark";
IconElementClass.metadata = {
  displayName: "Icon",
  iconPath: "mark/icon",
  creatingInteraction: {
    type: "point",
    mapping: {
      x: "x",
      y: "y"
    }
  }
};
IconElementClass.defaultProperties = {
  alignment: {
    x: "middle",
    y: "top",
    xMargin: 5,
    yMargin: 5
  },
  rotation: 0,
  visible: true
};
IconElementClass.defaultMappingValues = {
  opacity: 1,
  size: 400,
  visible: true
};
exports.IconElementClass = IconElementClass;